import React, { useState } from "react";
import { postEmpresa as addEmpresa } from "../helpers/rutaEmpresas";
import "../css/addclienteform.css";

const AddEmpresaForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    codemp: "",      // no hace falta cargarlo (autoincrement en back)
    empresa: "",
    cuit: "",
    domicilio: "",
  });

  const handleChange = (e) => {
    setFormValues((p) => ({
      ...p,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await addEmpresa(formValues);
      console.log("✅ Empresa creada:", resp);

      setFormValues({
        codemp: "",
        empresa: "",
        cuit: "",
        domicilio: "",
      });

      // si querés cerrar modal:
      // setShow(false);
    } catch (err) {
      console.error("❌ Error al crear empresa:", err);
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group mt-3 col-sm-5">
            <label>Empresa</label>
            <input
              type="text"
              className="form-control"
              name="empresa"
              maxLength="80"
              required
              value={formValues.empresa}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3 col-sm-3">
            <label>CUIT</label>
            <input
              type="text"
              className="form-control"
              name="cuit"
              maxLength="20"
              value={formValues.cuit}
              onChange={handleChange}
              placeholder="11 dígitos"
            />
          </div>

          <div className="form-group mt-3 col-sm-4">
            <label>Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              maxLength="120"
              value={formValues.domicilio}
              onChange={handleChange}
            />
          </div>
        </div>

        <div>
          <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEmpresaForm;
